// extracted by mini-css-extract-plugin
export default {"content":"content_content__6yKXo","baseInfo":"content_baseInfo__Bseu7","extraInfo":"content_extraInfo__qAAdF"};